import { render } from "./home-hero-sec.vue?vue&type=template&id=2fe240ee&scoped=true"
import script from "./home-hero-sec.vue?vue&type=script&lang=js"
export * from "./home-hero-sec.vue?vue&type=script&lang=js"

import "./home-hero-sec.vue?vue&type=style&index=0&id=2fe240ee&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe240ee"]])

export default __exports__